import { FC } from "react";
import FlexColumn from "shared/components/Layout/components/FlexColumn";
import SpaceBetweenCenter from "shared/components/Layout/components/SpaceBetweenCenter";
import { COLOR_BLACK } from "shared/theme/colors";
import CustomNumber from "../CustomNumber";
import GameCard from "../GameCard";

type NumericLayoutProps = {
  gameIds: string[];
  isNewlyGenerated?: boolean;
};

const NumericLayout: FC<NumericLayoutProps> = ({
  gameIds,
  isNewlyGenerated,
}) => {
  const sevenGameIds = gameIds?.slice(0, 7) || [];

  return (
    <SpaceBetweenCenter gap={2}>
      {sevenGameIds.map((gameId, index) => (
        <FlexColumn ai="flex-start" key={gameId} sx={{ position: "relative" }}>
          <CustomNumber
            label={String(index + 1)}
            bottom={"62px"}
            color={COLOR_BLACK}
          />
          <GameCard
            gameId={gameId}
            imageWidth="87px"
            imageHeight="114px"
            maxWidth="87px"
            marginLeft="40px"
            index={index}
            isNewlyGenerated={isNewlyGenerated}
          />
        </FlexColumn>
      ))}
    </SpaceBetweenCenter>
  );
};

export default NumericLayout;
